import { useState } from "react";

const contactStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&family=Cinzel:wght@400;600;700&family=Noto+Serif:ital,wght@0,400;0,600;1,400&display=swap');

  .contact-section {
    background: linear-gradient(180deg, #1a0000 0%, #2d0000 100%);
    padding: 5.5rem 2rem;
    position: relative; overflow: hidden;
  }

  /* top gold line */
  .contact-section::before {
    content: ''; position: absolute;
    top: 0; left: 0; right: 0; height: 3px;
    background: linear-gradient(90deg, transparent, #C9920A, #F0C040, #C9920A, transparent);
  }

  /* decorative orb */
  .contact-section::after {
    content: ''; position: absolute;
    bottom: -200px; left: -200px;
    width: 500px; height: 500px; border-radius: 50%;
    background: radial-gradient(circle, rgba(139,0,0,0.12), transparent 60%);
    pointer-events: none;
  }

  .contact-inner {
    max-width: 1150px; margin: 0 auto;
    position: relative; z-index: 1;
  }

  /* Header */
  .contact-header { text-align: center; margin-bottom: 4rem; }

  .contact-eyebrow {
    font-family: 'Cinzel', serif;
    font-size: 0.7rem; font-weight: 600;
    letter-spacing: 0.3em; text-transform: uppercase;
    color: #C9920A; margin-bottom: 0.75rem;
    display: flex; align-items: center; justify-content: center; gap: 12px;
  }
  .contact-eyebrow::before,
  .contact-eyebrow::after {
    content: ''; height: 1px; width: 50px;
    background: linear-gradient(90deg, transparent, #C9920A);
  }
  .contact-eyebrow::after {
    background: linear-gradient(90deg, #C9920A, transparent);
  }

  .contact-title {
    font-family: 'Cinzel Decorative', serif;
    font-size: 2rem; font-weight: 700;
    color: #F0C040;
    text-shadow: 0 0 30px rgba(240,192,64,0.25);
  }

  /* Grid */
  .contact-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    align-items: start;
  }

  /* ── FORM ── */
  .contact-form-wrap {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(201,146,10,0.18);
    border-radius: 6px;
    padding: 2.5rem 2rem;
  }

  .form-group { margin-bottom: 1.5rem; }

  .form-label {
    display: block;
    font-family: 'Cinzel', serif;
    font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.15em; text-transform: uppercase;
    color: #C9920A; margin-bottom: 0.6rem;
  }

  .form-input,
  .form-textarea {
    width: 100%; padding: 12px 16px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(201,146,10,0.25);
    border-radius: 3px;
    color: #e8d5b0;
    font-family: 'Noto Serif', serif;
    font-size: 0.95rem;
    transition: all 0.25s;
    outline: none;
    box-sizing: border-box;
  }

  .form-input::placeholder,
  .form-textarea::placeholder {
    color: rgba(200,160,100,0.35);
    font-style: italic;
  }

  .form-input:focus,
  .form-textarea:focus {
    border-color: #C9920A;
    background: rgba(201,146,10,0.06);
    box-shadow: 0 0 0 3px rgba(201,146,10,0.12);
  }

  .form-textarea { resize: vertical; min-height: 130px; }

  .form-submit {
    width: 100%;
    display: flex; align-items: center; justify-content: center; gap: 10px;
    font-family: 'Cinzel', serif;
    font-size: 0.82rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: #4A0000;
    background: linear-gradient(135deg, #F0C040, #C9920A);
    padding: 14px 28px; border: none; border-radius: 3px;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(201,146,10,0.3);
    transition: all 0.3s;
  }

  .form-submit:hover {
    box-shadow: 0 6px 30px rgba(201,146,10,0.5);
    transform: translateY(-2px);
  }

  .form-submit:active { transform: translateY(0); }

  .form-submit.sent {
    background: linear-gradient(135deg, #2d6a4f, #1a4a35);
    color: #a8e6c8;
    box-shadow: 0 4px 20px rgba(45,106,79,0.3);
  }

  /* ── MAP ── */
  .map-wrap {
    border: 1px solid rgba(201,146,10,0.2);
    border-top: 2px solid #C9920A;
    border-radius: 6px; overflow: hidden;
    box-shadow: 0 12px 40px rgba(0,0,0,0.35);
    display: flex; flex-direction: column;
  }

  .map-header {
    background: rgba(255,255,255,0.03);
    border-bottom: 1px solid rgba(201,146,10,0.15);
    padding: 1.1rem 1.5rem;
    display: flex; align-items: center; gap: 10px;
  }

  .map-header-icon {
    width: 36px; height: 36px; border-radius: 50%;
    background: linear-gradient(135deg, rgba(139,0,0,0.5), rgba(70,0,0,0.8));
    border: 1px solid rgba(201,146,10,0.35);
    display: flex; align-items: center; justify-content: center;
    font-size: 1rem;
  }

  .map-header-text {
    font-family: 'Cinzel', serif;
    font-size: 0.78rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase;
    color: #C9920A;
  }

  .map-header-sub {
    font-family: 'Noto Serif', serif;
    font-size: 0.78rem; color: rgba(200,160,100,0.6);
  }

  .map-iframe-wrap {
    flex: 1;
    min-height: 380px;
    background: #1a0a0a;
    display: flex; align-items: center; justify-content: center;
  }

  .map-iframe-wrap iframe {
    width: 100%; height: 380px; border: none; display: block;
  }

  /* Map placeholder (shown until real embed is added) */
  .map-placeholder {
    width: 100%; height: 380px;
    display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 1rem;
    background: linear-gradient(160deg, #1a0000, #2d0000);
  }

  .map-placeholder .map-pin { font-size: 3rem; animation: bounce 2s ease-in-out infinite; }

  @keyframes bounce {
    0%,100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }

  .map-placeholder p {
    font-family: 'Cinzel', serif; font-size: 0.8rem;
    letter-spacing: 0.15em; text-transform: uppercase;
    color: rgba(201,146,10,0.5);
  }

  .map-footer {
    padding: 1rem 1.5rem;
    background: rgba(255,255,255,0.02);
    border-top: 1px solid rgba(201,146,10,0.12);
  }

  .map-address-text {
    font-family: 'Noto Serif', serif;
    font-size: 0.85rem; color: #b8906a; line-height: 1.6;
  }

  .map-directions-link {
    display: inline-flex; align-items: center; gap: 6px;
    font-family: 'Cinzel', serif; font-size: 0.7rem;
    font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase;
    color: #F0C040; text-decoration: none;
    margin-top: 0.6rem; transition: gap 0.2s;
  }

  .map-directions-link:hover { gap: 10px; }

  @media (max-width: 768px) {
    .contact-grid { grid-template-columns: 1fr; }
    .contact-title { font-size: 1.6rem; }
  }
`;

const ContactForm = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3500);
  };

  return (
    <>
      <style>{contactStyles}</style>
      <section className="contact-section" id="contact">
        <div className="contact-inner">

          <div className="contact-header">
            <p className="contact-eyebrow">Reach Out to Us</p>
            <h2 className="contact-title">Contact Us</h2>
          </div>

          <div className="contact-grid">

            {/* ── LEFT: FORM ── */}
            <div className="contact-form-wrap">
              <form onSubmit={handleSubmit}>

                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input
                    className="form-input"
                    type="text" name="name"
                    placeholder="Enter your name"
                    value={form.name} onChange={handleChange} required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    className="form-input"
                    type="email" name="email"
                    placeholder="Enter your email"
                    value={form.email} onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input
                    className="form-input"
                    type="tel" name="phone"
                    placeholder="+91 00000 00000"
                    value={form.phone} onChange={handleChange} required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Message</label>
                  <textarea
                    className="form-textarea"
                    name="message"
                    placeholder="Write your message or pooja enquiry..."
                    value={form.message} onChange={handleChange} required
                  />
                </div>

                <button type="submit" className={`form-submit ${sent ? "sent" : ""}`}>
                  {sent ? "✓ Message Sent!" : "Send Message →"}
                </button>

              </form>
            </div>

            {/* ── RIGHT: MAP ── */}
            <div className="map-wrap">
              <div className="map-header">
                <div className="map-header-icon">📍</div>
                <div>
                  <div className="map-header-text">Temple Location</div>
                  <div className="map-header-sub">Vellore – 632004, Tamil Nadu</div>
                </div>
              </div>

              <div className="map-iframe-wrap">
                {/* 
                  Replace the placeholder below with your actual iframe:
                  <iframe
                    src="https://www.google.com/maps/embed?pb=YOUR_EMBED_LINK_HERE"
                    title="Temple Location" allowFullScreen loading="lazy"
                  />
                */}
                <div className="map-placeholder">
                  <div className="map-pin">📍</div>
                  <p>Paste Your Google Maps Embed URL</p>
                </div>
              </div>

              <div className="map-footer">
                <p className="map-address-text">
                  No. 35, Beri Kaliamman Kovil Street, Beri Pettai,<br />
                  Near Gandhi Road & Main Bazaar, Vellore – 632004
                </p>
                <a
                  href="https://maps.google.com/?q=Beri+Kaliamman+Kovil+Street+Vellore"
                  target="_blank" rel="noopener noreferrer"
                  className="map-directions-link"
                >
                  Get Directions →
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;